import { render } from "./NotFound.vue?vue&type=template&id=724fe700"
const script = {}
script.render = render

export default script